<template>
  <div :class="['tva-video-preview-component', {'last' : content.last === true}]">
    <div
      class="background-image"
      :style="{backgroundImage: `url(${baseUrl}images/${content.img}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`}"
    ></div>
    <div :class="['gradient-image']"></div>
    <div class="video-preview-content">
      <h4 class="white">{{content.title}}</h4>
      <p class="white" v-html="content.text">{{content.text}}</p>
      <div
        v-if="$tvaMq === 'desktop'"
        class="image"
        :style="{backgroundImage: `url(${baseUrl}images/${content.imgTop}${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`}"
      ></div>
      <template v-if="content.video">
        <router-link :to="{name: 'video', params: {videoId: `${content.video}`}}">
          <div class="call-to-action">
            <div class="play-box">
              <svgicon class="play" icon="play" height="10" width="10"></svgicon>
            </div>
            <div class="text">{{content.callToAction}}</div>
          </div>
        </router-link>
      </template>
      <template v-else>
        <a :href="content.link" target="blank">
          <div class="call-to-action">
            <div class="freccia-box">
              <svgicon class="freccia" icon="freccia" height="20" width="20"></svgicon>
            </div>
            <div class="text">{{content.callToAction}}</div>
          </div>
        </a>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  props: ["content"],
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";
.tva-video-preview-component {
  height: 60vh;
  min-height: 700px;
  width: 100vw;
  margin: 6vw 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  &.last {
    margin-bottom: 0px;
  }
  .background-image {
    height: 110%;
    width: 110%;
    position: absolute;
    top: -5%;
    left: -5%;
    filter: blur(8px);
    -webkit-filter: blur(8px);
    background-size: cover;
    background-position: center;
    z-index: -2;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .gradient-image {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: -1;
  }
  .video-preview-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 750px;
    text-align: center;
    .white {
      width: 100%;
    }
    h4 {
      margin-bottom: 20px;
    }
    .image {
      width: 500px;
      height: 280px;
      margin: 50px 0;
      background-size: cover;
      background-position: center;
    }
    .call-to-action {
      border-right: solid 1px $eni-yellow;
      border-top: solid 1px $eni-yellow;
      border-bottom: solid 1px $eni-yellow;
      border-radius: 30px;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        .text {
          color: $eni-yellow;
        }

        .play-box {
          background: $eni-yellow;
          .svg-icon {
            fill: #000;
            stroke: #000;
          }
        }
        .freccia-box {
          background: $eni-yellow;
          .svg-icon {
            stroke: #000;
          }
        }
      }
      .freccia-box,
      .play-box {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 40px;
        width: 40px;
        border: solid 1px $eni-yellow;
        border-radius: 50%;
        transition: all 0.3s ease;
      }
      .play-box {
        .svg-icon {
          fill: $eni-yellow;
          stroke: $eni-yellow;
          transition: all 0.3s ease;
        }
      }
      .freccia-box {
        .svg-icon {
          stroke: $eni-yellow;
          fill: none;
          transition: all 0.3s ease;
        }
      }

      .text {
        font-family: "Avenir Next";
        font-size: 14px;
        font-weight: 500;
        line-height: 1.14;
        letter-spacing: 0.5px;
        color: #ffffff;
        text-transform: uppercase;
        padding: 0 17px 0 12px;
        text-decoration: none;
        transition: all 0.3s ease;
      }
    }
  }
}
@media (max-width: 1024px) {
  .tva-video-preview-component {
    display: flex;
    align-items: center;
    justify-content: center;
    background: black;
    display: flex;
    align-items: flex-end;
    padding: 30px 0;
    .background-image {
      position: absolute;
      top: 0;
      left: 0;
      filter: none;
      background-repeat: no-repeat;
      background-size: cover !important;
      background-position: 0% 0% !important;
      width: 100vw;
      height: 40vh;
      z-index: 3;
      &::after {
        content: "";
        position: absolute;
        bottom: -10px;
        left: 0;
        height: 100%;
        width: 100%;
        background: linear-gradient(
          to bottom,
          rgba(0, 0, 0, 0) 50%,
          rgba(0, 0, 0, 0.5) 80%,
          rgba(0, 0, 0, 1) 90%,
          rgba(0, 0, 0, 1) 100%
        );
      }
    }
    .gradient-image {
      display: none;
    }
    .video-preview-content {
      padding: 20px 100px;
      z-index: 3;
      h4 {
        text-align: center;
      }
      p {
        margin-bottom: 30px;
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-video-preview-component {
    min-height: 500px !important;
    align-items: flex-end;
    padding: 20px 0;
    .background-image {
      filter: none;
      height: 200px;
      width: 100vw;
    }
    .gradient-image {
      background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0.1) 0%,
        rgba(0, 0, 0, 1) 60%,
        rgba(0, 0, 0, 1) 100%
      );
    }
    .video-preview-content {
      padding: 20px;
      h4 {
        text-align: center;
      }
      p {
        margin-bottom: 30px;
      }
    }
  }
}
</style>


